import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)`
  width: ${(p) => p.theme.spacing(34)};
`;
